<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="75%" persistent>
      <v-card>
        <div class="pos-abs-fixed">
          <v-toolbar 
            dense 
            color="grey lighten-2"
          >
            <v-toolbar-title class="title">{{ titleModal }}</v-toolbar-title>
            <v-divider
              class="mx-2"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn flat fab small icon @click="$emit('input')" slot="activator">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cancelar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                color="primary"
                fab
                dark
                small
                @click="adiciona"
                :loading="loading"
                slot="activator"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <span>Salvar</span>
            </v-tooltip>
          </v-toolbar>
        </div>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field 
                v-model="layoutSql.Descricao" 
                label="Descrição do layout sql"
                @keyup.enter="adiciona"
                autofocus
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field 
                v-model="layoutSql.Titulo" 
                label="Título"
                @keyup.enter="adiciona"
                autofocus
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-3>
              <v-autocomplete
                v-model="layoutSql.RecursoSistema"
                :items="recursosSistemaAtivo"
                item-text="Descricao"
                return-object
                menu-props="auto"
                label="Recurso Sistema"
                hide-details
                class="mb-3"
                no-data-text="Registro não encontrado."
                outline
                auto-select-first
                @change="changeRecursoSistema"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md6 pl-3>
              <v-autocomplete
                v-model="layoutSql.DescricaoSql"
                :items="sqlsAtivo"
                item-text="Descricao"
                return-object
                menu-props="auto"
                label="Sql"
                hide-details
                class="mb-3"
                no-data-text="Registro não encontrado."
                outline
                auto-select-first
                @change="changeSql"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-tabs
            v-model="tabActive"
            slider-color="grey"
            @change="changeTab"
          >
            <v-tab ripple>
              <v-subheader class="px-0 font-weight-bold">Configurações</v-subheader>
            </v-tab>
            <v-tab ripple>
              <v-subheader class="px-0 font-weight-bold">Preferências</v-subheader>
            </v-tab>
            <v-tab ripple>
              <v-subheader class="px-0 font-weight-bold">Usuários</v-subheader>
            </v-tab>
            <v-tab-item>
              <v-divider></v-divider>
              <v-layout row wrap justify-center mt-3>
                <v-flex xs2 align-self-center>
                  <h4>Visualização em:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-radio-group v-model="jsonConfiguracoes.tipoVisualizacao" row>
                    <v-radio label="Lista" value="lista" class="pr-4" color="primary"></v-radio>
                    <v-radio label="Coluna" value="coluna" color="primary"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout v-if="jsonConfiguracoes.tipoVisualizacao === 'coluna'" row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Agrupador:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-radio-group v-model="jsonConfiguracoes.agrupador" row>
                    <v-radio label="Situação" value="situacao" color="primary"></v-radio>
                    <!-- <v-radio label="Período" value="periodo" color="primary"></v-radio> -->
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <!-- Tipos Recurso -->
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Tipos Recurso:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-select
                    v-model="jsonConfigTiposRecurso"
                    :items="tiposRecurso"
                    item-text="Descricao"
                    return-object
                    multiple
                    chips
                  >
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="toggleTiposRecurso"
                    >
                      <v-list-tile-action>
                        <v-icon :color="jsonConfiguracoes.tiposRecursoSelected.length > 0 ? 'primary' : ''">{{ iconTiposRecursoSelected }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar Todos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        @input="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="primary white--text"
                          v-text="data.item.Descricao.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item.Descricao }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <!-- Status -->
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Status:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-select
                    v-model="jsonConfiguracoes.statusSelected"
                    :items="statusRecurso"
                    multiple
                    chips
                  >
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="toggleStatus"
                    >
                      <v-list-tile-action>
                        <v-icon :color="jsonConfiguracoes.statusSelected.length > 0 ? 'primary' : ''">{{ iconStatusSelected }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar Todos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        @input="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="primary white--text"
                          v-text="data.item.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <!-- Situações -->
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Situações:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-select
                    v-model="jsonConfigSituacoes"
                    :items="situacoesRecurso"
                    item-text="Descricao"
                    return-object
                    multiple
                    chips
                  >
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="toggleSituacoes"
                    >
                      <v-list-tile-action>
                        <v-icon :color="jsonConfiguracoes.situacoesSelected.length > 0 ? 'primary' : ''">{{ iconSituacoesSelected }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar Todos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        @input="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="primary white--text"
                          v-text="data.item.Descricao.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item.Descricao }}
                      </v-chip>
                    </template>
                  </v-select>
                  <v-btn
                    small
                    block
                    v-if="json.situacoesSelected.length"
                    @click="mostraOrdenacaoSituacao = !mostraOrdenacaoSituacao"
                  >
                    Ordenar Situações
                  </v-btn>
                  <v-card v-if="mostraOrdenacaoSituacao && json.situacoesSelected.length">
                    <v-card-text class="pa-0">
                      <v-list class="pa-0">
                        <draggable v-model="jsonSituacoesSelectedOrdenada" @start="drag=true" @end="drag=false">
                          <v-list-tile v-for="(situacao, i) of jsonSituacoesSelectedOrdenada" :key="i" class="listitem">
                            <v-list-tile-title>{{ i }} - {{ situacao.Descricao }}</v-list-tile-title>
                          </v-list-tile>
                        </draggable>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <!-- Tags -->
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Tags:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-select
                    v-model="jsonConfigTags"
                    :items="tagsRecurso"
                    item-text="Descricao"
                    return-object
                    multiple
                    chips
                  >
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="toggleTags"
                    >
                      <v-list-tile-action>
                        <v-icon :color="jsonConfiguracoes.tagsSelected && jsonConfiguracoes.tagsSelected.length > 0 ? 'primary' : ''">{{ iconTagsSelected }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar Todas</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        @input="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="primary white--text"
                          v-text="data.item.Descricao.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item.Descricao }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <!-- Workflows -->
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Workflows:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-select
                    v-model="jsonConfigWorkflows"
                    :items="workflowsRecurso"
                    item-text="Descricao"
                    return-object
                    multiple
                    chips
                  >
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="toggleWorkflows"
                    >
                      <v-list-tile-action>
                        <v-icon :color="jsonConfiguracoes.workflowsSelected && jsonConfiguracoes.workflowsSelected.length > 0 ? 'primary' : ''">{{ iconWorkflowsSelected }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar Todas</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        @input="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="primary white--text"
                          v-text="data.item.Descricao.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item.Descricao }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <!-- Colaboradores -->
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Colaboradores:</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-select
                    v-model="jsonConfigColaboradores"
                    :items="colaboradores"
                    item-text="Descricao"
                    return-object
                    multiple
                    chips
                  >
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="toggleColaboradores"
                    >
                      <v-list-tile-action>
                        <v-icon :color="jsonConfiguracoes.colaboradoresSelected.length > 0 ? 'primary' : ''">{{ iconColaboradoresSelected }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar Todos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        @input="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="primary white--text"
                          v-text="data.item.Descricao.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item.Descricao }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Filtrar Responsável?</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-checkbox
                    v-model="jsonConfiguracoes.FiltrarResponsavel"
                    color="primary"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex xs2 align-self-center>
                  <h4>Filtrar Interessado?</h4>
                </v-flex>
                <v-flex xs10 pl-3>
                  <v-checkbox
                    v-model="jsonConfiguracoes.FiltrarInteressado"
                    color="primary"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-divider></v-divider>
              <v-layout row wrap justify-center mt-3>
                <v-flex xs12 align-self-center>
                  <SharedTextarea
                    :value="jsonConfiguracoes.Preferencias"
                    @change="v => jsonConfiguracoes.Preferencias = v"
                    label="Preferências" 
                    hide-details
                    outline
                    spellcheck="false"
                    class="font-code"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-divider></v-divider>
              <v-layout row wrap justify-center mt-3>
                <v-flex xs12 align-self-center>
                  <v-autocomplete
                    v-model="layoutSqlUsuario.Descricao"
                    :items="usuarios"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Adicionar Usuário"
                    hide-details
                    prepend-icon="group_add"
                    class="mb-3"
                    no-data-text="Registro não encontrado."
                    auto-select-first
                    @change="changeLayoutSqlUsuario"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-card v-if="layoutsSqlUsuarios.length" class="projeto-detalhes-item interessados mr-2">
                    <v-subheader class="grey lighten-2 font-weight-bold">Usuários</v-subheader>
                    <v-divider></v-divider>
                    <v-card-text class="px-3">
                      <v-chip
                        @input="excluiUsuario(usuario)" 
                        close v-for="usuario in layoutsSqlUsuarios" :key="usuario.IdUsuario">
                        <v-avatar class="primary white--text">{{ usuario.Descricao[0] }}</v-avatar>
                        {{ usuario.Descricao }}
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import LayoutSql from '@/domain/layoutSql/LayoutSql';
import PesquisaRecursoJson from '@/domain/pesquisaRecursoJson/PesquisaRecursoJson';
import LayoutSqlUsuario from '@/domain/layoutSql/LayoutSqlUsuario';
import draggable from 'vuedraggable';
import SharedTextarea from '@/components/shared/Textarea';

export default {
  name: 'ModalCadastroLayoutSql',
  props: ['editLayoutSql', 'value'],
  components: {
    draggable,
    SharedTextarea
  },
  data() {
    return {
      layoutSqlUsuario: new LayoutSqlUsuario(),
      tabActive: null,
      loading: false,
      newLayoutSql: new LayoutSql(),
      json: new PesquisaRecursoJson(),
      statusAtividade: ['PENDENTE', 'FINALIZADA', 'CANCELADA'],
      statusProjeto: ['ATIVO', 'FINALIZADO', 'CANCELADO'],
      statusOcorrencia: ['ATIVA', 'PENDENTE', 'FINALIZADA', 'CANCELADA'],
      statusGeral: ['ATIVO', 'INATIVO', 'CANCELADO'],
      mostraOrdenacaoSituacao: false,
    }
  },
  computed: {
    ...mapGetters([
      'sqlsAtivo', 
      'recursosSistemaAtivo',
      'situacoesAtividade',
      'situacoesProjeto',
      'tiposAtividade',
      'tiposProjeto',
      'tiposOcorrencia',
      'tiposSituacao',
      'tags',
      'workflows',
      'colaboradores',
      'usuarios',
      'layoutsSqlUsuarios'
    ]),
    tiposRecurso() {
      if (this.layoutSql.IdRecursoSistema === 100002) return this.tiposAtividade;
      if (this.layoutSql.IdRecursoSistema === 100003) return this.tiposProjeto;
      if (this.layoutSql.IdRecursoSistema === 100004) return this.tiposOcorrencia;
      if (this.layoutSql.IdRecursoSistema === 100005) return this.tiposSituacao;
      return [];
    },
    situacoesRecurso() {
      if (this.layoutSql.IdRecursoSistema === 100002) return this.situacoesAtividade;
      if (this.layoutSql.IdRecursoSistema === 100003) return this.situacoesProjeto;
      return [];
    },
    tagsRecurso() {
      if (this.layoutSql.IdRecursoSistema === 100002) return this.tags;
      if (this.layoutSql.IdRecursoSistema === 100003) return this.tags;
      return [];
    },
    workflowsRecurso() {
      if (this.layoutSql.IdRecursoSistema === 100002) return this.workflows;
      if (this.layoutSql.IdRecursoSistema === 100003) return this.workflows;
      return [];
    },
    statusRecurso() {
      if (this.layoutSql.IdRecursoSistema === 100002) return this.statusAtividade;
      if (this.layoutSql.IdRecursoSistema === 100003) return this.statusProjeto;
      if (this.layoutSql.IdRecursoSistema === 100004) return this.statusOcorrencia;
      if (this.layoutSql.IdRecursoSistema === 100005) return this.statusGeral;
      if (this.layoutSql.IdRecursoSistema === 100006) return this.statusGeral;
      return this.statusGeral;
    },
    layoutSql() {
      return this.editLayoutSql ? this.newLayoutSql = this.editLayoutSql : this.newLayoutSql = new LayoutSql();
    },
    jsonConfiguracoes() {
      return this.editLayoutSql && this.editLayoutSql.Configuracoes !== null ? this.json = JSON.parse(this.editLayoutSql.Configuracoes) : this.json = new PesquisaRecursoJson();
    },
    jsonSituacoesSelectedOrdenada: {
      get() {
        return this.json.situacoesSelected;
      },
      set(value) {
        this.json.situacoesSelected = value;
      }
    },
    // Computed property para montar o array de tipos de acordo com os IDs
    jsonConfigTiposRecurso: {
      get() {
        // Tipos Atividade
        if (this.layoutSql.IdRecursoSistema === 100002) { 
          const tipos = [];
          this.tiposAtividade.filter(tipo => {
            this.jsonConfiguracoes.tiposRecursoSelected.forEach(tipoSelected => {
              if (tipo.IdTipoAtividade == tipoSelected) tipos.push(tipo);
            });
          });
          return tipos;
        }
        // Tipos Projeto
        if (this.layoutSql.IdRecursoSistema === 100003) {
          const tipos = [];
          this.tiposProjeto.filter(tipo => {
            this.jsonConfiguracoes.tiposRecursoSelected.forEach(tipoSelected => {
              if (tipo.IdTipoProjeto == tipoSelected) tipos.push(tipo);
            });
          });
          return tipos;
        }
        // Tipos Ocorrência
        if (this.layoutSql.IdRecursoSistema === 100004) { 
          const tipos = [];
          this.tiposOcorrencia.filter(tipo => {
            this.jsonConfiguracoes.tiposRecursoSelected.forEach(tipoSelected => {
              if (tipo.IdTipoOcorrencia == tipoSelected) tipos.push(tipo);
            });
          });
          return tipos;
        }
        // Tipos Situação
        if (this.layoutSql.IdRecursoSistema === 100005) { 
          const tipos = [];
          this.tiposSituacao.filter(tipo => {
            this.jsonConfiguracoes.tiposRecursoSelected.forEach(tipoSelected => {
              if (tipo.IdTipoSituacao == tipoSelected) tipos.push(tipo);
            });
          });
          return tipos;
        }

        return [];
      },
      set(value) {
        if (this.layoutSql.IdRecursoSistema === 100002) {
          this.json.tiposRecursoSelected = value.map(item => item.IdTipoAtividade);
        }
        if (this.layoutSql.IdRecursoSistema === 100003) {
          this.json.tiposRecursoSelected = value.map(item => item.IdTipoProjeto);
        }
        if (this.layoutSql.IdRecursoSistema === 100004) {
          this.json.tiposRecursoSelected = value.map(item => item.IdTipoOcorrencia);
        }
        if (this.layoutSql.IdRecursoSistema === 100005) {
          this.json.tiposRecursoSelected = value.map(item => item.IdTipoSituacao);
        }
      }
    },
    // Computed property para montar o array de situacoes de acordo com os IDs
    jsonConfigSituacoes: {
      get() {
        // Situações Atividade
        if (this.layoutSql.IdRecursoSistema === 100002) { 
          const situacoes = [];
          this.situacoesAtividade.filter(situacao => {
            this.jsonConfiguracoes.situacoesSelected.forEach(situacaoSelected => {
              if (situacao.IdSituacao == situacaoSelected.IdSituacao) {
                const obj = { IdSituacao: situacao.IdSituacao, Descricao: situacao.Descricao };
                situacoes.push(obj);
              }
            });
          });
          return situacoes;
        }
        // Situações Projeto
        if (this.layoutSql.IdRecursoSistema === 100003) {
          const situacoes = [];
          this.situacoesProjeto.filter(situacao => {
            this.jsonConfiguracoes.situacoesSelected.forEach(situacaoSelected => {
              if (situacao.IdSituacao == situacaoSelected.IdSituacao) {
                const obj = { IdSituacao: situacao.IdSituacao, Descricao: situacao.Descricao };
                situacoes.push(obj);
              }
            });
          });
          return situacoes;
        }

        return [];
      },
      set(value) {
        this.json.situacoesSelected = value;
      }
    },
    // Computed property para montar o array de tags de acordo com os IDs
    jsonConfigTags: {
      get() {
        const tags = [];
        if (this.jsonConfiguracoes.tagsSelected) {
          this.tags.filter(tag => {
            this.jsonConfiguracoes.tagsSelected.forEach(tagSelected => {
              if (tag.IdTag == tagSelected) tags.push(tag);
            });
          });
        }
        return tags;
      },
      set(value) {
        this.json.tagsSelected = value.map(item => item.IdTag);
      }
    },
    // Computed property para montar o array de workflows de acordo com os IDs
    jsonConfigWorkflows: {
      get() {
        const workflows = [];
        if (this.jsonConfiguracoes.workflowsSelected) {
          this.workflows.filter(workflow => {
            this.jsonConfiguracoes.workflowsSelected.forEach(workflowSelected => {
              if (workflow.IdWorkflow == workflowSelected) workflows.push(workflow);
            });
          });
        }
        return workflows;
      },
      set(value) {
        this.json.workflowsSelected = value.map(item => item.IdWorkflow);
      }
    },
    // Computed property para montar o array de colaboradores de acordo com os IDs
    jsonConfigColaboradores: {
      get() {
        const colaboradores = [];
          this.colaboradores.filter(colaborador => {
            this.jsonConfiguracoes.colaboradoresSelected.forEach(colaboradorSelected => {
              if (colaborador.IdColaborador == colaboradorSelected) colaboradores.push(colaborador);
            });
          });
          return colaboradores;
      },
      set(value) {
        this.json.colaboradoresSelected = value.map(item => item.IdColaborador);
      }
    },
    titleModal() {
      return this.editLayoutSql ? 'Editar Layout Sql' : 'Novo Layout Sql';
    },
    todasTagsSelected() {
      return this.json.tagsSelected && this.json.tagsSelected.length === this.tags.length;
    },
    algumasTagsSelected() {
      return this.json.tagsSelected && this.json.tagsSelected.length > 0 && !this.todasTagsSelected;
    },
    iconTagsSelected() {
      if (this.todasTagsSelected) return 'check_box';
      if (this.algumasTagsSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    todosWorkflowsSelected() {
      return this.json.workflowsSelected && this.json.workflowsSelected.length === this.workflows.length;
    },
    algunsWorkflowsSelected() {
      return this.json.workflowsSelected && this.json.workflowsSelected.length > 0 && !this.todosWorkflowsSelected;
    },
    iconWorkflowsSelected() {
      if (this.todosWorkflowsSelected) return 'check_box';
      if (this.algunsWorkflowsSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    todosColaboradoresSelected() {
      return this.json.colaboradoresSelected.length === this.colaboradores.length;
    },
    algunsColaboradoresSelected() {
      return this.json.colaboradoresSelected.length > 0 && !this.todosColaboradoresSelected;
    },
    iconColaboradoresSelected() {
      if (this.todosColaboradoresSelected) return 'check_box';
      if (this.algunsColaboradoresSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    todasSituacoesSelected() {
      return this.json.situacoesSelected.length === this.situacoesRecurso.length;
    },
    algumasSituacoesSelected() {
      return this.json.situacoesSelected.length > 0 && !this.todasSituacoesSelected;
    },
    iconSituacoesSelected() {
      if (this.todasSituacoesSelected) return 'check_box';
      if (this.algumasSituacoesSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    todosStatusSelected() {
      return this.jsonConfiguracoes.statusSelected.length === this.statusRecurso.length;
    },
    algunsStatusSelected() {
      return this.jsonConfiguracoes.statusSelected.length > 0 && !this.todosStatusSelected;
    },
    iconStatusSelected() {
      if (this.todosStatusSelected) return 'check_box';
      if (this.algunsStatusSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    todosTiposRecursoSelected() {
      return this.json.tiposRecursoSelected.length === this.tiposRecurso.length;
    },
    algunsTiposRecursoSelected() {
      return this.json.tiposRecursoSelected.length > 0 && !this.todosTiposRecursoSelected;
    },
    iconTiposRecursoSelected() {
      if (this.todosTiposRecursoSelected) return 'check_box';
      if (this.algunsTiposRecursoSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
  },
  methods: {
    ...mapActions([
        'addLayoutSql',
        'updateLayoutSql',
        'fetchUsuarios',
        'fetchLayoutsSqlUsuarios',
        'addLayoutSqlUsuario',
        'deleteLayoutSqlUsuario'
      ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    toggleTags () {
      this.$nextTick(() => {
        if (this.todasTagsSelected) {
          this.jsonConfigTags = [];
        } else {
          this.jsonConfigTags = this.tags.slice();
        }
      })
    },
    toggleWorkflows () {
      this.$nextTick(() => {
        if (this.todosWorkflowsSelected) {
          this.jsonConfigWorkflows = [];
        } else {
          this.jsonConfigWorkflows = this.workflows.slice();
        }
      })
    },
    toggleColaboradores () {
      this.$nextTick(() => {
        if (this.todosColaboradoresSelected) {
          this.jsonConfigColaboradores = [];
        } else {
          this.jsonConfigColaboradores = this.colaboradores.slice();
        }
      })
    },
    toggleSituacoes () {
      this.$nextTick(() => {
        if (this.todasSituacoesSelected) {
          this.jsonConfigSituacoes = [];
        } else {
          this.jsonConfigSituacoes = this.situacoesRecurso.slice();
        }
      })
    },
    toggleTiposRecurso () {
      this.$nextTick(() => {
        if (this.todosTiposRecursoSelected) {
          this.jsonConfigTiposRecurso = [];
        } else {
          this.jsonConfigTiposRecurso = this.tiposRecurso.slice();
        }
      })
    },
    toggleStatus () {
      this.$nextTick(() => {
        if (this.todosStatusSelected) {
          this.jsonConfiguracoes.statusSelected = [];
        } else {
          this.jsonConfiguracoes.statusSelected = this.statusRecurso.slice();
        }
      })
    },
    changeSql(obj) {
      this.layoutSql.IdSql = obj.IdSql;
      this.layoutSql.DescricaoSql = obj.Descricao;
      this.layoutSql.InstrucaoSql = obj.InstrucaoSql;
    },
    changeRecursoSistema(obj) {
      this.layoutSql.IdRecursoSistema = obj.IdRecursoSistema;
      this.layoutSql.RecursoSistema = obj.Descricao;
    },
    changeTab(tab) {
      if (tab === 2) {
        if (!this.usuarios.length) {
          this.fetchUsuarios();
        }

        if (this.editLayoutSql) {
          this.fetchLayoutsSqlUsuarios(this.editLayoutSql.IdLayoutSql);
        }
      }
    },
    async changeLayoutSqlUsuario(obj) {
      this.layoutSqlUsuario.IdLayoutSql = this.editLayoutSql.IdLayoutSql;
      this.layoutSqlUsuario.IdUsuario = obj.IdUsuario;
      this.layoutSqlUsuario.Descricao = obj.Descricao;

      try {
        const usuarioAdicionado = await this.addLayoutSqlUsuario(this.layoutSqlUsuario);
        if (usuarioAdicionado && usuarioAdicionado.data.IdUsuario) {
          this.showNotification({ text: `Usuário ${obj.Descricao} adicionado ao layout sql.`, status: 'success' });
          this.layoutSqlUsuario = new LayoutSqlUsuario();
        }
      } catch (error) {
        this.showNotification({ text: `Ocorreu um erro ao adicionar o usuário: ${error}`, status: 'error' });
        this.layoutSqlUsuario = new LayoutSqlUsuario();
      }
    },
    async excluiUsuario(usuario) {
      if (confirm(`Remover: ${usuario.Descricao}?`)) {
        await this.deleteLayoutSqlUsuario(usuario);
        this.showNotification({ text: `Usuário ${usuario.Descricao} removido do layout sql.`, status: 'success' });
      }
    },
    async adiciona() {
      if (this.layoutSql.Descricao && this.layoutSql.IdRecursoSistema) {
        this.loading = true;
        this.layoutSql.Configuracoes = JSON.stringify(this.jsonConfiguracoes);
        try {
          if (!this.layoutSql.IdLayoutSql) {
            await this.addLayoutSql(this.layoutSql);
          } else {
            await this.updateLayoutSql(this.layoutSql);
          }
          this.loading = false;
          this.json = new PesquisaRecursoJson();
          this.$emit('input');
          this.$emit('layoutEditSalvo');
          this.showNotification({ text: `Layout Sql: ${this.layoutSql.Descricao} ${this.layoutSql.IdSql ? 'atualizado' : 'adicionado'} com sucesso.`, status: 'success' });
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o layout sql: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição e o Recurso Sistema do layout sql.`, status: 'error' });
      }
    }
  }
}
</script>

<style scoped>
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 50px;
}

.pos-abs-fixed > :first-child {
  position: fixed;
  max-width: 74.4%;
}

.listitem:hover {
  cursor: pointer;
  background: #e5e5e5;
}
</style>
